export default {
  NODE_ENV: process.env.NODE_ENV,
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
  APP_URL: process.env.VUE_APP_URL,

  /* Layouts of app */

  USE_ROOT: {
    root: true,
  },
  LAYOUT_AUTH: 'LAYOUT_AUTH',
  LAYOUT_APP: 'LAYOUT_APP',

  SUCCESS_COLOR: 'green',
  ERROR_COLOR: 'error',

  AGREEMENT_TYPE_STR: {
    0: 'Buying',
    1: 'Selling',
  },

  COLLECTION_UPLOADS: 'uploads',
  COLLECTION_ASSETS: 'assets',
  COLLECTION_DELIVERY: 'delivery',
  COLLECTION_DOCUMENTS: 'documents',

  MODEL_FILM: 'film',
  MODEL_AGREEMENT: 'agreement',

  MEDIA: {
    FILM: {
      SCREENERS: 'screeners',
      TRAILERS: 'trailers',
      ASSETS: 'Assets',
      DELIVERABLES: 'Deliverables',
      THUMBS: 'Thumbs',
      POSTERS: 'Posters',
    },
  },

  MIME_TYPE: {
    IMAGE: 'image',
    VIDEO: 'video',
    APPLICATION: 'application',
    ALL: 'all',
  },

  TAG_TYPE: {
    FOR_FILM_GENRE: 'film_genre',
    FOR_FILM_MEDIA: 'film_media',
    FOR_RIGHTS: 'film_rights',
    FOR_FILM_COUNTRIES: 'film_countries',
    FOR_TERRITORIES: 'territories',
    FOR_LANGUAGES: 'languages',
    FOR_FILM_TYPE: 'film_type',
    FOR_FILM_FORMAT: 'film_format',
    FOR_FILM_RANDOM: 'film_random',
    FOR_FILM_ARTIST: 'film_artist',
    FILM_CONTRACT_TYPE: 'film_contract_type',
    FILM_RELEASE_YEAR: 'film_release_year',
  },
  AVAIL_SESSION_MODE: 'avail',

  TIME_LIMITS: [
    {
      title: '7 Days',
      value: 7,
    },
    {
      title: '14 Days',
      value: 14,
    },
    {
      title: '30 Days',
      value: 30,
    },
    {
      title: '2 Months',
      value: 60,
    },
    {
      title: '3 Months',
      value: 90,
    },
    {
      title: '6 Months',
      value: 180,
    },
    {
      title: '1 Year',
      value: 365,
    },
  ],
  //role of company users
  ROLE_BUYER: 110,
  ROLE_RIGHT_HOLDER: 120,
  ROLE_MEMBER: 130,
  ROLE_ADMIN: 140,
  ROLE_OWNER: 150,
};
